import { P } from '@decisiv/ui-components/lib/components/Typography';

import { FilterWrapper } from './styles';

type Props = {
  text: string;
  active?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const TabButton = ({ text, active = false, ...rest }: Props) => {
  return (
    <FilterWrapper $isActive={active} {...rest} role="button" tabIndex={0}>
      <P paddingY={0.2} paddingX={1}>
        {text}
      </P>
    </FilterWrapper>
  );
};
